import { Pay } from "src/pages/LeanDeposit/tools/leanFunctions.js";
import swal from 'sweetalert';

import {
  customerDetails,
  PaymentDestination,
  createIntents,
} from "src/pages/LeanDeposit/tools/callRequest";

// button link new bank helper
export const getcustomerId = async (clientId) => {
  let customerId = "";
  try {
    const value = await customerDetails(clientId);
    customerId = value?.data?.data?.providerCustomerId;
    return customerId;
  } catch {
    console.error("cannot get customer Details");
    return null;
  }
};

export const getPaymentDestinationId = async (finamazeBankIndex) => {
  let value = await PaymentDestination();
  // need to change
  const DestinationId = value?.data?.data[finamazeBankIndex]?.id;
  if (DestinationId) {
    return DestinationId;
  } else {
    console.error(
      "cannot get customer Details and can't create payment source",
    );
    return null;
  }
};

//button for payment helper

const creatPaymentIntentId = async (intents) => {
  let value = await createIntents(intents);
  if (value?.success === false) {
    swal("Forbidden", value.message, "error")
  }
  const IntentId = value?.data?.data?.payment_intent_id;
  if (IntentId) {
    return IntentId;
  } else {
    console.error("cannot get Intent Id");
    return null;
  }
};

export const creatPayment = (intents, payCallback) => {
  creatPaymentIntentId(intents)
    .then((res) => {
      if (res) {
        Pay(res, payCallback);
      }
    })
    .catch(() => {
      return "failed";
    }
    );
};